import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useFeatureFlag } from 'api/configuration/features/hooks/useFeatureFlag';
import { resolve } from 'api/resolve';
import { type CommonUpdater, useUpdateByQueryKey } from 'hooks/useUpdateByQueryKey';

import { useSubscriptionsApi } from '../subscriptions-api';
import { FETCH_CURRENT_SUBSCRIPTION_QUERY_KEY } from '../subscriptions-query-keys';
import type { SubscriptionViewModel } from '../types';

export const useFetchCurrentSubscription = () => {
  const { getCurrent } = useSubscriptionsApi();
  const isIntegrationsEnabled = useFeatureFlag('Integrations');

  return useQuery({
    queryKey: FETCH_CURRENT_SUBSCRIPTION_QUERY_KEY,
    queryFn: async () => {
      const subscription = await resolve(getCurrent());
      if (!isIntegrationsEnabled) {
        subscription.features = subscription.features.filter((feature) => feature.name !== 'IntegrationsAdministrator');
      }
      return subscription;
    }
  });
};

/** Update Subscription cache without refetch. */
export const useUpdateCurrentSubscription = () => {
  const update = useUpdateByQueryKey();

  return useCallback(
    (updater: CommonUpdater<SubscriptionViewModel>) => {
      return update(FETCH_CURRENT_SUBSCRIPTION_QUERY_KEY, updater);
    },
    [update]
  );
};
